<template>
    <div class="container mt-5 mb-3 text-center">
        <hr class="mt-2 mb-2">
           <span class="footer">SCKAN KB Version {{ version }}</span>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            version: "",
        }
    },
    mounted() {
        const that = this;
        axios.get('/explorer_api/sckan_version')
            .then(function(response) {
                that.version = response.data['version']
            })
            .catch(function(err) {
                console.log(err);
                that.version = '';
            });
    }
}
</script>
<style scoped>
.footer {
    font-family: sans-serif;
    font-size: 11pt;
}
</style>